import React, { useState } from 'react';
import SalesEnquiry from './SalesEnquiry';
import SalesQuotation from './SalesQuotation';
import SalesApprovals from './SalesApprovals';



import SalesExecutive from './SalesExecutive';
import SalesManager from './SalesManager';
import Enquiry from './Enquiry/Enquiry';
import Food from './Food/Food';
import Logistics from './Logistics/Logistics';

const SalesManagement = () => {
    const [activeTab, setActiveTab] = useState('Enquiry'); // 'enquiry', 'quotation', or 'approvals'

    return (
        <div style={{ padding: '20px' }}>
            {/* Tabs */}
            <div style={tabsContainerStyle}>

                {/* <button
                    onClick={() => setActiveTab('Food')}
                    style={{
                        ...tabStyle,
                        background: activeTab === 'Food' ? '#e66d33' : '#f0f0f0',
                        color: activeTab === 'Food' ? '#fff' : '#666',
                    }}
                >
                    Food
                </button>


                <button
                    onClick={() => setActiveTab('Logistics')}
                    style={{
                        ...tabStyle,
                        background: activeTab === 'Logistics' ? '#e66d33' : '#f0f0f0',
                        color: activeTab === 'Logistics' ? '#fff' : '#666',
                    }}
                >
                    Logistics
                </button> */}
                <button
                    onClick={() => setActiveTab('Enquiry')}
                    style={{
                        ...tabStyle,
                        background: activeTab === 'Enquiry' ? '#e66d33' : '#f0f0f0',
                        color: activeTab === 'Enquiry' ? '#fff' : '#666',
                    }}
                >
                    Enquiry
                </button>

                <button
                    onClick={() => setActiveTab('salesExecutive')}
                    style={{
                        ...tabStyle,
                        background: activeTab === 'salesExecutive' ? '#e66d33' : '#f0f0f0',
                        color: activeTab === 'salesExecutive' ? '#fff' : '#666',
                    }}
                >
                    Sales Executive
                </button>
                <button
                    onClick={() => setActiveTab('salesManager')}
                    style={{
                        ...tabStyle,
                        background: activeTab === 'salesManager' ? '#e66d33' : '#f0f0f0',
                        color: activeTab === 'salesManager' ? '#fff' : '#666',
                    }}
                >
                    Sales Manager
                </button>




            </div>

            {/* Tab Content */}
            <div style={{}}>
                {activeTab === 'enquiry' && <SalesEnquiry />}
                {activeTab === 'quotation' && <SalesQuotation />}
                {activeTab === 'approvals' && <SalesApprovals />}
                {activeTab === 'salesExecutive' && <SalesExecutive />}
                {activeTab === 'salesManager' && <SalesManager />}
                {activeTab === 'Enquiry' && <Enquiry />}

                {activeTab === 'Food' && <Food />}
                {activeTab === 'Logistics' && <Logistics />}
            </div>
        </div>
    );
};

const tabsContainerStyle = {
    display: 'flex',
    gap: '10px',
    paddingBottom: '10px',
    marginTop: '60px',
    borderBottom: '2px solid #e66d33',
};

const tabStyle = {
    padding: '10px 24px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
};

export default SalesManagement;